import { useSelector } from 'react-redux';
import {
  selectGuaranteesAccounts,
  selectGuaranteesAccountsError,
  selectGuaranteesAccountsStatus,
  selectGuaranteesApplicationTimeline,
  selectGuaranteesApplicationTimelineStatus,
  selectGuaranteesApplicationTenderInfo,
  selectGuaranteesApplicationTenderInfoError,
  selectGuaranteesApplicationTenderInfoStatus,
  selectGuaranteesBaseRelations,
  selectGuaranteesBaseRelationsError,
  selectGuaranteesBaseRelationsStatus,
  selectGuaranteesBeneficiary,
  selectGuaranteesBeneficiaryError,
  selectGuaranteesBeneficiaryStatus,
  selectGuaranteesCheckApplicationRequestError,
  selectGuaranteesCheckApplicationRequestStatus,
  selectGuaranteesCurrentApplication,
  selectGuaranteesCurrentApplicationError,
  selectGuaranteesCurrentApplicationStatus,
  selectGuaranteesFetchProzorroTender,
  selectGuaranteesFetchProzorroTenderError,
  selectGuaranteesFetchProzorroTenderStatus,
  selectGuaranteesForm,
  selectGuaranteesFormError,
  selectGuaranteesFormStatus,
  selectGuaranteesMainDeals,
  selectGuaranteesMainDealsError,
  selectGuaranteesMainDealsStatus,
  selectGuaranteesPatchApplicationMainDealError,
  selectGuaranteesPatchApplicationMainDealStatus,
  selectGuaranteesPatchApplicationSecretError,
  selectGuaranteesPatchApplicationSecretStatus,
  selectGuaranteesPrincipalDebitAccounts,
  selectGuaranteesPrincipalDebitAccountsError,
  selectGuaranteesPrincipalDebitAccountsStatus,
  selectGuaranteesPatchApplicationTenderError,
  selectGuaranteesPatchApplicationTenderStatus,
  selectGuaranteesPutSecurityCurrenciesError,
  selectGuaranteesPutSecurityCurrenciesStatus,
  selectGuaranteesPatchBaseRelationsError,
  selectGuaranteesPatchBaseRelationsStatus,
  selectGuaranteesPatchBeneficiaryError,
  selectGuaranteesPatchBeneficiaryStatus,
  selectGuaranteesPatchFormError,
  selectGuaranteesPatchFormStatus,
  selectGuaranteesPatchPrincipalError,
  selectGuaranteesPatchPrincipalStatus,
  selectGuaranteesPatchRootApplicationSectionError,
  selectGuaranteesPatchRootApplicationSectionStatus,
  selectGuaranteesPrincipal,
  selectGuaranteesPrincipalError,
  selectGuaranteesPrincipalStatus,
  selectGuaranteesSecurityCurrencies,
  selectGuaranteesSecurityCurrenciesError,
  selectGuaranteesSecurityCurrenciesStatus,
} from '~/store/guarantees/selectors.ts';
import { GuaranteesFetchStatus } from '~/store/guarantees/types.ts';

export const useGuaranteesApplicationPageState = () => {
  const application = useSelector(selectGuaranteesCurrentApplication);
  const applicationStatus = useSelector(selectGuaranteesCurrentApplicationStatus);
  const applicationError = useSelector(selectGuaranteesCurrentApplicationError);
  const applicationTimeline = useSelector(selectGuaranteesApplicationTimeline);
  const applicationTimelineStatus = useSelector(selectGuaranteesApplicationTimelineStatus);
  const applicationTenderInfo = useSelector(selectGuaranteesApplicationTenderInfo);
  const applicationTenderInfoStatus = useSelector(selectGuaranteesApplicationTenderInfoStatus);
  const applicationTenderInfoError = useSelector(selectGuaranteesApplicationTenderInfoError);
  const checkApplicationRequestStatus = useSelector(selectGuaranteesCheckApplicationRequestStatus);
  const checkApplicationRequestError = useSelector(selectGuaranteesCheckApplicationRequestError);
  const patchRootStatus = useSelector(selectGuaranteesPatchRootApplicationSectionStatus);
  const patchRootError = useSelector(selectGuaranteesPatchRootApplicationSectionError);
  const principal = useSelector(selectGuaranteesPrincipal);
  const principalStatus = useSelector(selectGuaranteesPrincipalStatus);
  const principalError = useSelector(selectGuaranteesPrincipalError);
  const patchPrincipalStatus = useSelector(selectGuaranteesPatchPrincipalStatus);
  const patchPrincipalError = useSelector(selectGuaranteesPatchPrincipalError);
  const beneficiary = useSelector(selectGuaranteesBeneficiary);
  const beneficiaryStatus = useSelector(selectGuaranteesBeneficiaryStatus);
  const beneficiaryError = useSelector(selectGuaranteesBeneficiaryError);
  const patchBeneficiaryStatus = useSelector(selectGuaranteesPatchBeneficiaryStatus);
  const patchBeneficiaryError = useSelector(selectGuaranteesPatchBeneficiaryError);
  const baseRelations = useSelector(selectGuaranteesBaseRelations);
  const baseRelationsStatus = useSelector(selectGuaranteesBaseRelationsStatus);
  const baseRelationsError = useSelector(selectGuaranteesBaseRelationsError);
  const patchBaseRelationsStatus = useSelector(selectGuaranteesPatchBaseRelationsStatus);
  const patchBaseRelationsError = useSelector(selectGuaranteesPatchBaseRelationsError);
  const guaranteeForm = useSelector(selectGuaranteesForm);
  const guaranteeFormStatus = useSelector(selectGuaranteesFormStatus);
  const guaranteeFormError = useSelector(selectGuaranteesFormError);
  const patchGuaranteeFormStatus = useSelector(selectGuaranteesPatchFormStatus);
  const patchGuaranteeFormError = useSelector(selectGuaranteesPatchFormError);
  const patchTenderStatus = useSelector(selectGuaranteesPatchApplicationTenderStatus);
  const patchTenderError = useSelector(selectGuaranteesPatchApplicationTenderError);
  const patchMainDealStatus = useSelector(selectGuaranteesPatchApplicationMainDealStatus);
  const patchMainDealError = useSelector(selectGuaranteesPatchApplicationMainDealError);
  const patchSecretStatus = useSelector(selectGuaranteesPatchApplicationSecretStatus);
  const patchSecretError = useSelector(selectGuaranteesPatchApplicationSecretError);
  const securityCurrencies = useSelector(selectGuaranteesSecurityCurrencies);
  const securityCurrenciesStatus = useSelector(selectGuaranteesSecurityCurrenciesStatus);
  const securityCurrenciesError = useSelector(selectGuaranteesSecurityCurrenciesError);
  const putSecurityCurrenciesStatus = useSelector(selectGuaranteesPutSecurityCurrenciesStatus);
  const putSecurityCurrenciesError = useSelector(selectGuaranteesPutSecurityCurrenciesError);
  const prozorroTender = useSelector(selectGuaranteesFetchProzorroTender);
  const fetchProzorroTenderStatus = useSelector(selectGuaranteesFetchProzorroTenderStatus);
  const fetchProzorroTenderError = useSelector(selectGuaranteesFetchProzorroTenderError);
  const mainDeals = useSelector(selectGuaranteesMainDeals);
  const mainDealsStatus = useSelector(selectGuaranteesMainDealsStatus);
  const mainDealsError = useSelector(selectGuaranteesMainDealsError);
  const accounts = useSelector(selectGuaranteesAccounts);
  const accountsStatus = useSelector(selectGuaranteesAccountsStatus);
  const accountsError = useSelector(selectGuaranteesAccountsError);
  const principalDebitAccounts = useSelector(selectGuaranteesPrincipalDebitAccounts);
  const principalDebitAccountsStatus = useSelector(selectGuaranteesPrincipalDebitAccountsStatus);
  const principalDebitAccountsError = useSelector(selectGuaranteesPrincipalDebitAccountsError);
  const requestError =
    applicationError ||
    applicationTenderInfoError ||
    checkApplicationRequestError ||
    patchRootError ||
    principalError ||
    patchPrincipalError ||
    beneficiaryError ||
    patchBeneficiaryError ||
    baseRelationsError ||
    patchBaseRelationsError ||
    guaranteeFormError ||
    patchGuaranteeFormError ||
    patchTenderError ||
    patchMainDealError ||
    patchSecretError ||
    securityCurrenciesError ||
    putSecurityCurrenciesError ||
    fetchProzorroTenderError ||
    mainDealsError ||
    accountsError ||
    principalDebitAccountsError;

  return {
    application,
    applicationTimeline,
    applicationTenderInfo,
    principal,
    beneficiary,
    baseRelations,
    guaranteeForm,
    prozorroTender,
    mainDeals,
    accounts,
    principalDebitAccounts,
    securityCurrencies,
    requestError,
    isApplicationLoading: applicationStatus === GuaranteesFetchStatus.Loading && !application,
    isApplicationTimelineLoading: applicationTimelineStatus === GuaranteesFetchStatus.Loading,
    isApplicationTenderInfoLoading:
      applicationTenderInfoStatus === GuaranteesFetchStatus.Loading,
    isCheckingApplication: checkApplicationRequestStatus === GuaranteesFetchStatus.Loading,
    isSavingRootSection: patchRootStatus === GuaranteesFetchStatus.Loading,
    isPrincipalLoading: principalStatus === GuaranteesFetchStatus.Loading,
    isSavingPrincipal: patchPrincipalStatus === GuaranteesFetchStatus.Loading,
    isBeneficiaryLoading: beneficiaryStatus === GuaranteesFetchStatus.Loading,
    isSavingBeneficiary: patchBeneficiaryStatus === GuaranteesFetchStatus.Loading,
    isBaseRelationsLoading: baseRelationsStatus === GuaranteesFetchStatus.Loading,
    isSavingBaseRelations: patchBaseRelationsStatus === GuaranteesFetchStatus.Loading,
    isGuaranteeFormLoading: guaranteeFormStatus === GuaranteesFetchStatus.Loading,
    isSavingGuaranteeForm: patchGuaranteeFormStatus === GuaranteesFetchStatus.Loading,
    isSearchingTender: fetchProzorroTenderStatus === GuaranteesFetchStatus.Loading,
    isSelectingTender: patchTenderStatus === GuaranteesFetchStatus.Loading,
    isSelectingMainDeal: patchMainDealStatus === GuaranteesFetchStatus.Loading,
    isSavingSecret:
      patchSecretStatus === GuaranteesFetchStatus.Loading ||
      putSecurityCurrenciesStatus === GuaranteesFetchStatus.Loading,
    isLoadingSecurityCurrencies: securityCurrenciesStatus === GuaranteesFetchStatus.Loading,
    isLoadingMainDeals: mainDealsStatus === GuaranteesFetchStatus.Loading,
    isLoadingAccounts: accountsStatus === GuaranteesFetchStatus.Loading,
    isLoadingPrincipalDebitAccounts:
      principalDebitAccountsStatus === GuaranteesFetchStatus.Loading,
  };
};
